import { render } from "./afterMovies.vue?vue&type=template&id=138dc26c"
const script = {}

import "./afterMovies.vue?vue&type=style&index=0&id=138dc26c&lang=css"

import exportComponent from "/var/www/__turkey-23/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__